import React, { useEffect, useState, useRef } from "react";
import { Link, NavLink } from "react-router-dom";
import { Container, Image, Media, Button, Badge } from "react-bootstrap";
import configuration from "react-global-configuration";
import VerifiedBadgeNoShadow from "../../Handlers/VerifiedBadgeNoShadow";
// import SideBarIndex from "../SideBar/SideBarIndex";
import io from "socket.io-client";
import { updateNotificationCount } from "../../../store/actions/NotificationAction";
import { fetchUserDetailsStart } from "../../../store/actions/UserAction";
import Alert from "react-bootstrap/Alert";
import { connect } from "react-redux";
import { translate, t } from "react-multi-lang";
import api from "../../../Environment";
import { SocketState } from '../../Socket/SocketProvider'
import "./HeaderIndex.css"
import MobileHeader from "./MobileHeader";

const HeaderIndex = (props) => {
  const [chatCount, setChatCount] = useState(0);
  const [bellCount, setBellCount] = useState(0);
  const { chatSocket, setChatSocket, chatSocketUrl, liveStreamSocketUrl, setLiveStreamSocketUrl, setChatSocketUrl } = SocketState()

  useEffect(() => {
    if (localStorage.getItem("userId") && props.profile?.loading) {
      props.dispatch(fetchUserDetailsStart());
    }
    if (liveStreamSocketUrl == "") setLiveStreamSocketUrl(configuration.get("configData.livestream_socket_url"));
    if (chatSocketUrl == "")
      setChatSocketUrl(configuration.get("configData.chat_socket_url"));
    // setChatSocketUrl("http://localhost:3012");

  }, []);

  useEffect(() => {
    // if (liveStreamSocketUrl == "") setLiveStreamSocketUrl(configuration.get("configData.livestream_socket_url"));
    if (chatSocketUrl != "") {
      // if (configuration.get("configData.is_notification_count_enabled") == 1) {
      chatSocketConnect();
      // }
    }

  }, [chatSocket]);

  const chatSocketConnect = () => {
    if (chatSocketUrl === "") {
      console.log("no keys configured");
    }

    if (chatSocket != null) {
      chatSocket.emit("notification update", {
        commonid: "user_id_" + localStorage.getItem("userId"),
        myid: localStorage.getItem("userId"),
      });

      if (localStorage.getItem("socket") == "true" || localStorage.getItem("socket") == true) {
        chatSocket.on("notification", (newData) => {
          setChatCount(newData?.chat_notification);
          setBellCount(newData?.bell_notification);
        });
      } else {
        console.log(false);
        // chatSocket.disconnect();
      }
    }
  };

  const [isVisible, setIsVisible] = useState(false);

  return (
    <>
      {localStorage.getItem("userId") ? (
        <>
          <MobileHeader />
          <header className="main-header">
            <Container>
              <nav className="main-header-menu d-flex">
                <Link
                  to={"/home"}
                  className="logo-div"
                  onClick={() => setIsVisible(false)}
                >
                  <Image
                    src={api.serviceUrl() +
                      "/" + configuration.get("configData.site_logo")}
                    className="logo-image"
                  />
                </Link>

                {/* Right Links */}
                <div className="header-links d-flex">

                  <NavLink
                    to={"/home"}
                    className="menu-style icon-with-round-hover"
                    activeClassName="active m-current"
                    onClick={() => setIsVisible(false)}
                  >
                    <Image
                      src={window.location.origin + "/assets/images/icons/home.svg"}
                      className="menu-image menu-image-bold"
                    />
                    <span className="menu-title">
                      {t("home")}
                    </span>
                  </NavLink>

                  <NavLink
                    to={"/events"}
                    className="menu-style icon-with-round-hover header-events-link"
                    activeClassName="active m-current"
                    isActive={(match, location) => {
                      return !!match || location.pathname.startsWith("/event/");
                    }}
                    onClick={() => setIsVisible(false)}
                  >
                    <Image
                      src={window.location.origin + "/assets/images/icons/calender-alt.svg"}
                      className="menu-image"
                    />
                    <span className="menu-title">
                      {t("events")}
                    </span>
                  </NavLink>

                  <Link
                    to={"/liveStreamCreate"}
                    className="menu-style icon-with-round-hover"
                    onClick={() => setIsVisible(false)}
                  >
                    <Image
                      src={
                        window.location.origin + "/assets/images/icons/video.svg"
                      }
                      className="menu-image"
                    />
                    <span className="menu-title">
                      {t("live")}
                    </span>
                  </Link>

                  <Link
                    to={"/posts-create"}
                    className="menu-style icon-with-round-hover"
                    onClick={() => setIsVisible(false)}
                  >
                    <Image
                      src={
                        window.location.origin +
                        "/assets/images/icons/create-post.svg"
                      }
                      className="menu-image menu-image-bold"
                    />
                    <span className="menu-title">
                      {t("post")}
                    </span>
                  </Link>

                  <Link
                    to={"/inbox"}
                    className="menu-style icon-with-round-hover"
                    style={{ position: "relative" }}
                    onClick={() => setIsVisible(false)}
                  >
                    <div style={{ position: "relative", display: "inline-block" }}>
                      <Image
                        src={window.location.origin + "/assets/images/icons/chat.svg"}
                        className="menu-image menu-image-bold"
                      />
                    </div>

                    {chatCount > 0 ? (
                      <Badge className="badge-notify">
                        {chatCount}
                      </Badge>
                    ) : (
                      ""
                    )}
                    <span className="menu-title">
                      {t("inbox")}
                    </span>
                  </Link>

                  <Link
                    to={"/notification"}
                    className="menu-style icon-with-round-hover"
                    style={{ position: "relative" }}
                    active-classname="m-current"
                    exact-active-classname=""
                    onClick={() => {
                      setIsVisible(false);
                      // notification count read socket call
                      if (chatSocket && chatSocket != null) {
                        chatSocket.emit("markNotificationRead", {
                          user_id: localStorage.getItem("userId")
                        });
                      }

                    }
                    }
                  >
                    <div style={{ position: "relative", display: "inline-block" }}>
                      <Image
                        src={
                          window.location.origin +
                          "/assets/images/icons/notification.svg"
                        }
                        className="menu-image menu-image-bold"
                      />
                    </div>
                    {bellCount > 0 ? (
                      <Badge className="badge-notify">
                        {bellCount}
                      </Badge>
                    ) : (
                      ""
                    )}
                    <span className="menu-title">
                      {t("notification")}
                    </span>
                  </Link>

                  <a
                    className="menu-style icon-with-round-hover"
                    href="#"
                    data-drawer-trigger
                    aria-controls="drawer-name"
                    aria-expanded="false"
                    onClick={() => setIsVisible(!isVisible)}
                  >
                    <Image
                      src={window.location.origin + "/assets/images/icons/user.svg"}
                      className="menu-image menu-image-bold"
                    />
                    <span className="menu-title">
                      {t("profile")}
                    </span>
                  </a>
                </div>
              </nav>

              {/* {localStorage.getItem("is_document_verified") == 3 ? (
                  <div className="pl-2">
                    <Alert key={1} variant='danger'>
                      The user updated documents decined by Admin.
                    </Alert>
                  </div>
                ) : null} */}
            </Container>
          </header>
        </>
      ) : (
        <>
          <MobileHeader />
          <header className="main-header">
            <Container>
              <nav className="main-header-menu d-flex">
                <Link
                  to={"/home"}
                  className="logo-div"
                  onClick={() => setIsVisible(false)}
                >
                  <Image
                    src={api.serviceUrl() +
                      "/" + configuration.get("configData.site_logo")}
                    className="logo-image"
                  />
                </Link>

                {/* Right Links */}
                <div className="header-links d-flex">

                  <NavLink
                    to={"/events"}
                    className="menu-style icon-with-round-hover header-events-link"
                    activeClassName="active m-current"
                    isActive={(match, location) => {
                      return !!match || location.pathname.startsWith("/event/");
                    }}
                    onClick={() => setIsVisible(false)}
                  >
                    <Image
                      src={window.location.origin + "/assets/images/icons/calender-alt.svg"}
                      className="menu-image"
                    />
                    <span className="menu-title">
                      {t("events")}
                    </span>
                  </NavLink>

                  <Link
                    to={"/signin"}
                    className="menu-style icon-with-round-hover m-current"
                    onClick={() => setIsVisible(false)}
                  >
                    <i className="fa fa-user" style={{
                      fontSize: "x-large"
                    }}></i>
                    <span className="menu-title">
                      {t("login")}
                    </span>
                  </Link>

                  <Link
                    to={"/signup"}
                    className="menu-style icon-with-round-hover"
                    onClick={() => setIsVisible(false)}
                  >
                    <i className="fa fa-user-plus" style={{
                      fontSize: "x-large",
                      // textAlign: "center",
                      // alignContent: "center"
                    }}></i>

                    <span className="menu-title">
                      {t("signup")}
                    </span>
                  </Link>

                </div>
              </nav>
            </Container>
          </header>
        </>
      )}
      {isVisible && localStorage.getItem("userId") ? (
        <div className="drawer" id="drawer-name" data-drawer-target>
          <div
            className="drawer__overlay"
            data-drawer-close
            tabIndex="-1"
          ></div>
          <div className="drawer__wrapper" style={{
            overflowY: "auto"
          }}>
            <div className="drawer__header">
              <div className="drawer__title">
                <Link to="#" className="l-sidebar__avatar" data-name="Profile">

                  <span className="sidebar-hamburger-user-profile">
                    <Image
                      src={
                        localStorage.getItem("user_picture") != "null"
                          ? api.serviceUrl() +
                          "/" +
                          localStorage.getItem("user_picture")
                          : "/assets/images/upload-profile-img.svg"
                      }
                      alt={localStorage.getItem("username")}
                    />
                  </span>

                  <div className="side-user-head">
                    <Link
                      to={"/profile"}
                      onClick={() => setIsVisible(!isVisible)}

                    >
                      <div className="d-flex">
                        <h3 className="g-user-name pr-2 text-dark">
                          {localStorage.getItem("name")}
                        </h3>
                        {localStorage.getItem("is_verified_badge") == 1 ? (
                          <div className="d-flex">
                            <VerifiedBadgeNoShadow />
                          </div>
                        ) : null}
                      </div>
                      <span className="user-id">
                        @{localStorage.getItem("username")}
                      </span>
                    </Link>
                  </div>

                  <span onClick={() => setIsVisible(!isVisible)} style={{
                    position: "absolute",
                    right: 0
                  }}>
                    {" "}
                    <i className="material-icons add-icon text-dark">clear</i>
                  </span>
                </Link>

                <ul className="list-inline">
                  <Media as="li">
                    <Link
                      to={"/subscribers"}
                      onClick={() => setIsVisible(false)}
                    >
                      <span className="fans-follow">
                        {props.profile?.data?.total_followers !== undefined && props.profile?.data?.total_followers !== null
                          ? props.profile.data.total_followers
                          : Number(localStorage.getItem("total_followers") || 0)}
                      </span>{" "}
                      {t("fans")}
                    </Link>
                  </Media>
                  <Media as="li">
                    <Link
                      to={"/following"}
                      onClick={() => setIsVisible(false)}
                    >
                      <span className="fans-follow">
                        {props.profile?.data?.total_followings !== undefined && props.profile?.data?.total_followings !== null
                          ? props.profile.data.total_followings
                          : Number(localStorage.getItem("total_followings") || 0)}
                      </span>{" "}
                      {t("following")}
                    </Link>
                  </Media>
                </ul>

                {/* <div className="pull-right">
                  <span className="m-arrow">
                    <Image
                      src={
                        window.location.origin +
                        "/assets/images/icons/arrow-down.svg"
                      }
                      alt={configuration.get("configData.site_name")}
                    />
                  </span>
                </div> */}
              </div>
              {/* <Button
              className="drawer__close"
              data-drawer-close
              aria-label="Close Drawer"
            ></Button> */}
            </div>
            <div className="drawer__content">
              <div className="right-sidebar-menu-item">
                <Link
                  to={"/profile"}
                  className="sidebar-menus-item"
                  data-name="Profile"
                  onClick={() => setIsVisible(!isVisible)}
                >
                  <Image
                    src={
                      window.location.origin + "/assets/images/icons/user.svg"
                    }
                    alt={configuration.get("configData.site_name")}
                  />{" "}
                  {t("my_profile")}
                </Link>

                <Link
                  to={"/creator-dashboard"}
                  className="sidebar-menus-item"
                  data-name="Creator_dashboard"
                  onClick={() => setIsVisible(!isVisible)}
                >
                  <Image
                    src={
                      window.location.origin + "/assets/images/icons/analytics.svg"
                    }
                    alt={configuration.get("configData.site_name")}
                  />{" "}
                  {t("creator_dashboard")}
                </Link>

                <Link
                  to={"/my-bookings"}
                  className="sidebar-menus-item"
                  data-name="Profile"
                  onClick={() => setIsVisible(!isVisible)}
                >
                  <Image
                    src={
                      window.location.origin + "/assets/images/icons/calender-alt.svg"
                    }
                    alt={configuration.get("configData.site_name")}
                  />{" "}
                  {t("my_booking")}
                </Link>

                <Link
                  to={"/bookmarks"}
                  className="sidebar-menus-item"
                  data-name="Profile"
                  onClick={() => setIsVisible(!isVisible)}
                >
                  <Image
                    src={
                      window.location.origin +
                      "/assets/images/icons/bookmarks.svg"
                    }
                    alt={configuration.get("configData.site_name")}
                  />{" "}
                  {t("bookmarks")}
                </Link>

                <Link
                  to={"/streamList"}
                  className="sidebar-menus-item"
                  data-name="Profile"
                  onClick={() => setIsVisible(!isVisible)}
                >
                  <Image
                    src={
                      window.location.origin + "/assets/images/icons/lists.svg"
                    }
                    alt={configuration.get("configData.site_name")}
                  />{" "}
                  {t("livestream_lists")}
                </Link>

                {/* <Link
                  to={"/callRequest"}
                  className="sidebar-menus-item"
                  data-name="Profile"
                  onClick={() => setIsVisible(!isVisible)}
                >
                  <Image
                    src={
                      window.location.origin + "/assets/images/icons/lists.svg"
                    }
                    alt={configuration.get("configData.site_name")}
                  />{" "}
                  {t("call_list")}
                </Link> */}

                <Link
                  to={"/qrcode"}
                  className="sidebar-menus-item"
                  data-name="QRCode"
                  onClick={() => setIsVisible(!isVisible)}
                >
                  <i className="fas fa-qrcode fa-lg" style={{
                    marginRight: 15,
                    marginLeft: 4
                  }} />
                  {t("qrcode")}
                </Link>

                <Link
                  to={"/list"}
                  className="sidebar-menus-item"
                  data-name="Profile"
                  onClick={() => setIsVisible(!isVisible)}
                >
                  <Image
                    src={
                      window.location.origin + "/assets/images/icons/lists.svg"
                    }
                    alt={configuration.get("configData.site_name")}
                  />{" "}
                  {t("lists")}
                </Link>

                <Link
                  to={"/edit-profile"}
                  className="sidebar-menus-item"
                  data-name="Profile"
                  onClick={() => setIsVisible(!isVisible)}
                >
                  <Image
                    src={
                      window.location.origin +
                      "/assets/images/icons/settings.svg"
                    }
                    alt={configuration.get("configData.site_name")}
                  />{" "}
                  {t("settings")}
                </Link>

                <hr className="sidebar-menu-divider" />

                <Link
                  to={"/cards"}
                  className="sidebar-menus-item"
                  data-name="Profile"
                  onClick={() => setIsVisible(!isVisible)}
                >
                  <Image
                    src={
                      window.location.origin + "/assets/images/icons/card.svg"
                    }
                    alt="Your Cards"
                  />{" "}
                  {t("your_cards")}{" "}
                  <span className="desc">({t("to_subscribe")})</span>
                </Link>

                <Link
                  to={"/add-bank"}
                  className="sidebar-menus-item"
                  data-name="Profile"
                  onClick={() => setIsVisible(!isVisible)}
                >
                  <Image
                    src={
                      window.location.origin + "/assets/images/icons/bank.svg"
                    }
                    alt={configuration.get("configData.site_name")}
                  />{" "}
                  {t("add_bank")} <span className="desc">({t("to_earn")})</span>
                </Link>
                <Link
                  to={"/wallet"}
                  className="sidebar-menus-item"
                  data-name="Wallet"
                  onClick={() => setIsVisible(!isVisible)}
                >
                  <Image
                    src={
                      window.location.origin + "/assets/images/icons/wallet.svg"
                    }
                    alt={configuration.get("configData.site_name")}
                  />{" "}
                  {t("wallet")}{" "}
                  <span className="desc">({t("your_earnings")})</span>
                </Link>

                <hr className="sidebar-menu-divider" />

                <Link
                  to={`/page/help`}
                  className="sidebar-menus-item"
                  data-name="Profile"
                  onClick={() => setIsVisible(!isVisible)}
                >
                  <Image
                    src={
                      window.location.origin + "/assets/images/icons/help.svg"
                    }
                    alt={configuration.get("configData.site_name")}
                  />{" "}
                  {t("help_and_support")}
                </Link>

                <Link
                  to=""
                  className="sidebar-menus-item"
                  data-name="Profile"
                  onClick={() => setIsVisible(!isVisible)}
                  style={{ display: "none" }}
                >
                  <Image
                    src={
                      window.location.origin + "/assets/images/icons/dark.svg"
                    }
                    alt={configuration.get("configData.site_name")}
                  />{" "}
                  {t("dark_mode")}
                </Link>
                <hr className="sidebar-menu-divider" />
                <Link
                  to={"/logout"}
                  className="sidebar-menus-item"
                  data-name="Profile"
                  onClick={() => setIsVisible(!isVisible)}
                >
                  <Image
                    src={
                      window.location.origin + "/assets/images/icons/logout.svg"
                    }
                    alt={configuration.get("configData.site_name")}
                  />{" "}
                  {t("logout")}
                </Link>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

const mapStateToPros = (state) => ({
  notifications: state.notification.notifications,
  profile: state.users.profile,
});

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(
  mapStateToPros,
  mapDispatchToProps
)(translate(HeaderIndex));
